module.exports = __webpack_public_path__ + "static/munkalap_1-e041af2f610ac99738bc693d468546d5.png";